import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  EventCreate,
  EventType,
  MassEventMatching,
} from "src/store/api/generatedApi";
import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { parseFiniteNumber } from "src/utils/parseFiniteNumber";

dayjs.extend(utc);

export const isMassEventOutsideWindow = (
  massEvent: EventCreate | null,
  windowStart: Dayjs,
  windowEnd: Dayjs
): boolean => {
  if (massEvent === null) return false;
  const start = dayjs.utc(massEvent.event.start);
  const end = dayjs.utc(massEvent.event.end);
  return start.isBefore(windowStart) || end.isAfter(windowEnd);
};

export const isMassEventType = (
  eventType: EventType,
  massEventMatching: MassEventMatching | undefined
): boolean =>
  massEventMatching === "on_lift" ? eventType === "lift" : eventType === "drop";

export const resolveEventMass = ({
  event,
  massEventMatching,
}: {
  event: Pick<ScrapEyesEvent, "eventType" | "mass" | "recordedMass">;
  massEventMatching: MassEventMatching | undefined;
}): number | null => {
  if (event.recordedMass != null) return event.recordedMass;
  if (!isMassEventType(event.eventType, massEventMatching)) return null;
  return parseFiniteNumber(event.mass);
};

export const findPairedEventForMassWindow = <T extends ScrapEyesEvent>({
  event,
  allEvents,
  massEventMatching,
}: {
  event: T;
  allEvents: readonly T[];
  massEventMatching: MassEventMatching | undefined;
}): T | null => {
  if (massEventMatching !== "on_lift") return null;
  if (!event.pairId) return null;
  const partnerType: EventType = event.eventType === "lift" ? "drop" : "lift";
  return (
    allEvents.find(
      (other) =>
        other.pairId === event.pairId && other.eventType === partnerType
    ) ?? null
  );
};
